import { FileDownloadRequest, FileDownloadResponse, FileApiFactory } from '@/api'
import { BaseUserActionRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'

/**
 * ファイル情報取得処理
 */
export class CreateRequest extends BaseUserActionRequest {
  private fileDownload: FileDownloadRequest
  constructor(fileDownload: FileDownloadRequest) {
    super()
    this.fileDownload = fileDownload
  }
  protected request(): AxiosPromise<FileDownloadResponse> {
    const api = FileApiFactory()
    return api.fileDownloadCreate(this.fileDownload)
  }
}
